import React from 'react';
import * as Styles from './SiteBuilderV2.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import {
  Button, IconArrow,
  IconButton,
} from 'gatorcomponents';
import circlesImage from '@/media/onboarding/aiBuilder/circles-to-background.png';
import starImage from '@/media/onboarding/aiBuilder/star-to-background.png';

const SiteBuilderV2 = ({
  siteBuilderV2Locale,
  setCurrentFlow,
  cards,
  onGoBack,
}) => {
  React.useEffect(() => {
    setCurrentFlow('');
  }, [setCurrentFlow]);

  const handleGoBack = () => {
    onGoBack && onGoBack();
  };

  const mountCards = (id, icon, title, desc, action) => (
    <Styles.Card key={`card-${id}`}>
      <Styles.CardIcon>
        {icon}
      </Styles.CardIcon>
      <Styles.CardTitle>{title}</Styles.CardTitle>
      <Styles.CardDesc>{desc}</Styles.CardDesc>
      <Styles.CardButton>
        <Button
          iconRight={<IconArrow color="primaryBlue" direction="right" />}
          label={siteBuilderV2Locale.ctaContinue}
          onClick={() => action && action()}
          size="medium"
          testId="button"
          type="button"
          variant="secondary"
          version="v2"
          width="fit-content"
        />
      </Styles.CardButton>
    </Styles.Card>
  );

  return (
    <Styles.Wrapper data-testid="site-builder-v2-step">
      <Styles.ButtonBackWrapper>
        <IconButton
          testId="site-builder-v2-button-back"
          icon="IconArrow"
          onClick={handleGoBack}
        />
      </Styles.ButtonBackWrapper>

      <Styles.WaveTop>
        <Styles.CirclesImage src={circlesImage} alt="loading-circles" />
        <Styles.StarImage src={starImage} alt="loading-star" />
      </Styles.WaveTop>

      <Styles.InnerContainer>
        <Styles.TopBannerTitle>{siteBuilderV2Locale.topBannerTitle}</Styles.TopBannerTitle>

        <Styles.Title>{siteBuilderV2Locale.title}</Styles.Title>
        <Styles.Subtitle>{siteBuilderV2Locale.subtitle}</Styles.Subtitle>

        <Styles.WrapperCards>
          {cards.map(card => (
            mountCards(
              card.id,
              card.icon,
              card.title,
              card.desc,
              card.onClick,
            )
          ))}
        </Styles.WrapperCards>
      </Styles.InnerContainer>
    </Styles.Wrapper>
  );
};

export default withErrorBoundary(SiteBuilderV2, 'SiteBuilderV2');
